import { defineStore } from "pinia";
import axios, { AxiosError, AxiosResponse } from "axios";
import { UserRoleModel } from "@Shared/Models/UserRoleModel";

type OrganisationUsersModel = {
  organisationUsers: UserRoleModel[];
};

// @ts-ignore
const baseUrl = import.meta.env.VITE_APP_URL;

export type CreateOrgUserRequest = {
  organisationId: string;
  firstName: string;
  lastName: string;
  email: string;
  isOrgRegAdmin: boolean;
  isDSResponsible: boolean;
};

export const useOrganisationUsersStore = defineStore({
  id: "organisationUsers",
  state: (): OrganisationUsersModel => ({ organisationUsers: [] }),
  getters: {
    getOrganisationUsers: (state) => () => {
      return state.organisationUsers;
    },
    getOrganisationUser:
      (state) =>
      (id: string): UserRoleModel | null => {
        const organisationUser = state.organisationUsers.find(
          (user) => user.id === id
        );
        if (organisationUser) {
          return organisationUser;
        } else {
          return null;
        }
      },
  },
  actions: {
    async GetAllOrgUsers(orgId) {
      let path = `${baseUrl}/member/GetAllOrgUsers?organisationId=${orgId}`;
      let response: AxiosResponse;
      try {
        response = await axios.get(path);
      } catch (error: any) {
        console.log("error :", error);
        return Promise.reject(new Error(error));
      }
      if (response.status === 200) {
        this.$patch({ organisationUsers: response.data });
        return Promise.resolve();
      }
    },
    async CreateOrganisationUser(data: CreateOrgUserRequest) {
      let path = `${baseUrl}/member/SendInvitation`;
      let response: AxiosResponse<UserRoleModel>;
      try {
        response = await axios.post<UserRoleModel>(path, data);
      } catch (error: any) {
        console.log("error", error);
        return Promise.reject(new AxiosError(error));
      }
      if (response.status === 200) {
        await this.GetAllOrgUsers(data.organisationId);
        return Promise.resolve(true);
      }
      return Promise.reject(false);
    },
    async UpdateOrganisationUser(data: UserRoleModel) {
      let path = `${baseUrl}/member/UpdateRoles`;
      let response: AxiosResponse<UserRoleModel>;
      try {
        response = await axios.post<UserRoleModel>(path, data);
      } catch (error: any) {
        console.log("error", error);
        return Promise.reject(new Error(error));
      }
      if (response.status === 200) {
        //	Replace existing user with updated
        await this.GetAllOrgUsers(data.organisationId);
        return Promise.resolve(true);
      }
      return Promise.reject(false);
    },
    async DeleteOrganisationUser(data: UserRoleModel) {
      let path = `${baseUrl}/member/DeleteUser`;
      let response: AxiosResponse<UserRoleModel>;
      try {
        response = await axios.post<UserRoleModel>(path, data);
      } catch (error: any) {
        console.log("error", error);
        return Promise.reject(new Error(error));
      }
      if (response.status === 200) {
        return Promise.resolve(true);
      }
      return Promise.reject(false);
    },
  },
});
